module.exports = __webpack_public_path__ + "static/media/footwear.dd59fada.png";